import React, { useState, useRef } from 'react'
import { useDebounce } from '../../../../hooks/useDebounce'
import { Editor } from '../Editor/Editor'
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon'
import Aa from './img/Aa.svg'
import selected_icon from './img/selected.svg'
import "./TextArticle.scss"

const TextArticle = (({
  id,
  data,
  changeContent,
  setIsModal,
  ind,
  setCurrentIndex,
  before,
  setBeforeBlock,
  setContentArr,
  deleteBlock,
  readonly = false,
  addNewBlock,
}) => {
  const [content, setContent] = useState(data?.[0]?.value ? data?.[0]?.value : '')
  const ref = useRef()
  const debounceChange = useDebounce(changeContent, 1000)
  const [properties, setProperties] = useState({})
  const [isEditor, setIsEditor] = useState(false)

  const handleInput = (e) => {
    //  setContent(e.currentTarget.textContent)
    debounceChange(id,
      [
        {
          value: ref?.current?.innerHTML,
          properties: properties
        }
      ]
    )
    setContentArr((prev) => {
      return prev.map((el) => {
        if (el?.block_id == id) {
          return {
            ...el,
            content: [
              {
                value: ref?.current?.innerHTML
              }
            ]
          }
        } else {
          return el
        }
      })
    })
  }

  const handleDeleteBlock = (e) => {
    //  setContent(e.currentTarget.textContent)
    setContentArr((prev) => {
      return prev.filter((el) => {
        if (el?.block_id != id) {
          return el
        }
      })
    })
    deleteBlock(id)
  }

  // Регулярное выражение для поиска ссылок, начинающихся с пробела или новой 
  // строки, и заканчивающихся перед пробелом или новой строкой
  function wrapLinksInElement(str) {
    const linkPattern = /(?:\s|\n)(https?:\/\/[^\s\n]+)/g;

    return str.replace(linkPattern, (match, p1) => {
      return ` <a href=${p1} target='blank'  download='download'>${p1}</a>`
    });
  }

  // Вставка кода без форматирования
  // const handlePaste = (event) => {
  //   event.preventDefault(); // Отменяем стандартное поведение вставки
  //   const text = event.clipboardData.getData('text/plain'); // Получаем только текст
  //   document.execCommand('insertText', false, text); // Вставляем текст без форматирования
  // };

  const handlePaste = (event) => {
    event.preventDefault();

    let clipboardData = event.clipboardData || window.clipboardData;
    let pastedHTML = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

    if (pastedHTML) {
      let parser = new DOMParser();
      let doc = parser.parseFromString(pastedHTML, 'text/html');

      // Удаляем все теги <br>
      doc.querySelectorAll('br').forEach(el => el.remove());

      // Оставляем только безопасные теги
      const allowedTags = ['p', 'b', 'i', 'u', 'a'];
      doc.body.querySelectorAll('*').forEach(el => {
        if (!allowedTags.includes(el.tagName.toLowerCase())) {
          el.replaceWith(...el.childNodes); // Заменяем на чистый текст
        }
      });

      let cleanHTML = doc.body.innerHTML;

      // Вставляем очищенный HTML без форматирования
      document.execCommand('insertHTML', false, cleanHTML);
    }
  }


  // Обработчик нажатия клавиш
  const handleKeyDown = (e) => {
    // Обработка Ctrl+Enter для красной строки
    if (e.ctrlKey && e.key === 'Enter') {
      e.preventDefault();
      document.execCommand('insertLineBreak')
      return
    }

    if (e.key === 'Enter') {
      e.preventDefault();
      addNewBlock();
      return
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    }}>

      {/* <TextEditor /> */}
      {!readonly &&
        (isEditor && <Editor
          handleInput={handleInput}
        />)}

      <div className='article-text__wrapper'>
        {!readonly && <ButtonWithIcon
          icon={Aa}
          size='xs'
          onClick={(e) => setIsEditor(!isEditor)}
        />}

        {!readonly && <ButtonWithIcon
          icon={selected_icon}
          size='xs'
          onClick={(e) => {
            setCurrentIndex(ind)
            setIsModal(true)
          }}
        />}

        <p className={`article-text`}
          style={properties}
          tabIndex={0}
          autoFocus={true}
          shouldComponentUpdate
          suppressContentEditableWarning
          contentEditable={!readonly}
          dangerouslySetInnerHTML={{ __html: wrapLinksInElement(content) }}
          ref={ref}
          onInput={(e) => handleInput(e)}
          onContextMenu={(e) => {
            if (!readonly) {
              e.preventDefault()
              setCurrentIndex(ind)
              setIsModal(true)
            }
          }}
          onKeyDown={handleKeyDown}
          onClick={(e) => {
            setCurrentIndex(ind)
            setBeforeBlock(before)
          }}
          onPaste={handlePaste}
        >
          {/* {parse(wrapLinksInElement(content))} */}
        </p>
      </div>
    </div>
  )
})

export { TextArticle }